"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapCategoryColors = void 0;
var _models = require("../models");
const mapCategoryColors = ({
  palette
}) => ({
  [_models.Categories.ACCESSORIES]: palette.red[200],
  [_models.Categories.BATH_BODY]: palette.blue[300],
  [_models.Categories.ESSENTIAL_OILS]: palette.purple[50],
  [_models.Categories.FRAGRANCE]: palette.brown[100],
  [_models.Categories.HAIR]: palette.yellow[100],
  [_models.Categories.KIDS_BABY]: palette.blue[100],
  [_models.Categories.MAKEUP]: palette.pink[100],
  [_models.Categories.MEN]: palette.green[400],
  [_models.Categories.NUTRITION]: palette.purple[300],
  [_models.Categories.SKINCARE]: palette.green[100],
  [_models.Categories.WELLNESS]: palette.purple[300]
});
exports.mapCategoryColors = mapCategoryColors;
